export enum MapDataGroupId {
  APOfficial = 23,
  APOfficialTradeFlowMap = 40,
  AlternativeDatasets = 41,
}

export enum MapDataSourceId {
  HarmonizedDataset = 2,
  UNComtrade = 3,
  USDA_PSD = 10,
  OECD_FAO = 11,
  USDAForecast = 12,
  FAPRI2012 = 13,
  FAPRI = 14,
  FAOProdStat = 15,
  Default = HarmonizedDataset,
}

export enum MapDataSourceType {
  Historical = 'historical',
  Forecast = 'forecast',
}

export interface IMapDataSource {
  id: MapDataSourceId;
  identifier: string;
  name: string;
  type: MapDataSourceType;
  groupId: MapDataGroupId;
  group?: IMapDataGroup;
  order?: number;
  updateDate?: Date;
}

export interface IMapDataGroup {
  id: MapDataGroupId;
  name: string;
  order?: number;
  sources?: IMapDataSource[];
  group?: number;
}

export class MapDataSource implements IMapDataSource {
  group?: IMapDataGroup;
  updateDate?: Date;
  order?: number;

  constructor(public id: MapDataSourceId, public name: string, public groupId: MapDataGroupId, public type: MapDataSourceType, public identifier: string) {

  }

  static fromDTO(payload: object): MapDataSource {
    const id = payload['id'] as MapDataSourceId;
    const name = payload['name'] as string;
    const groupId = payload['parentId'] as MapDataGroupId;
    const type = payload['type'] as MapDataSourceType || MapDataSourceType.Historical;
    const identifier = payload['identifier'] as string;
    const source = new MapDataSource(id, name, groupId, type, identifier);
    source.updateDate = payload['lastUpdate'] && new Date(payload['lastUpdate']);
    source.order = payload['order'];
    return source;
  }
}

export class MapDataGroup implements IMapDataGroup {
  sources?: IMapDataSource[];
  order?: number;
  group?: number;

  constructor(public id: MapDataGroupId, public name: string) {

  }

  addSource(mapDataSource: MapDataSource) {
    this.sources = this.sources || [];
    this.sources!.push(mapDataSource);
    mapDataSource.group = this;
  }

  setSources(mapDataSources: MapDataSource[]) {
    mapDataSources.forEach(e => this.addSource(e));
  }

  static fromDTO(payload: object): MapDataGroup {
    const id = payload['id'] as MapDataGroupId;
    const name = payload['name'] as string;
    const group = new MapDataGroup(id, name);
    group.order = payload['order'];
    group.group = payload['group'];
    return group;
  }
}
